const breadcrumbs = document.querySelectorAll(".breadcrumbs")

breadcrumbs.forEach((breadcrumb) => {
  const dropdown = breadcrumb.querySelector(".breadcrumbs__dropdown")

  dropdown?.addEventListener("click", (event) => {
    event.preventDefault()
    breadcrumb.classList.toggle("--active")
  })
})
